// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TApC","placeholdersHeader":"styles_placeholdersHeader__AbEsV","editorStyle":"styles_editorStyle__1rM0c","placeholdersBox":"styles_placeholdersBox__17AeQ"};